import { Injectable } from '@angular/core';
import {AppConfig} from '../../app.config';
import {BlobServiceClient, BlobUploadCommonResponse, ContainerClient} from '@azure/storage-blob';
import {BehaviorSubject, Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AzureBlobStorageService {
  accountLink = this.appConfig.data.accountLink;
  containerName = this.appConfig.data.containerName;

  constructor(
    private appConfig: AppConfig,
  ) { }

  private containerClient(sas: string): ContainerClient {
    return new BlobServiceClient(`${this.accountLink}?${sas}`)
      .getContainerClient(this.containerName);
  }

  public uploadImage(sas: string, content: Blob, name: string): Observable<number> {
    const loading$ = new BehaviorSubject(0);
    const blockBlobClient = this.containerClient(sas).getBlockBlobClient(name);

    blockBlobClient.uploadData(content, {blobHTTPHeaders: {blobContentType: content.type}, onProgress: (progress) => loading$.next(Math.round(progress.loadedBytes / content.size * 100))});
    return loading$;
  }

  public deleteImage(sas: string, name: string): Observable<any> {
    return of(this.containerClient(sas).deleteBlob(name));
  }
}
